import { render } from "./BindPhone.vue?vue&type=template&id=4a4598b6&scoped=true"
import script from "./BindPhone.vue?vue&type=script&lang=js"
export * from "./BindPhone.vue?vue&type=script&lang=js"

import "./BindPhone.vue?vue&type=style&index=0&id=4a4598b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4598b6"]])

export default __exports__